var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['banner', `${_vm.type}`]},[(!_vm.slotExist)?_c('div',{staticClass:"flex items-center gap-3"},[_c('div',[_c('IconInfo',{attrs:{"color_prop":_vm.iconColor}})],1),_c('div',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }